module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAHCAYAAADTcMcaAAAAkElEQVQYlYWQMQoCQQxF33qQvcJPYeEV1lt5Ai9gu4XNgiwLdoKljWNpJ4LniMw64MwUGkgg5L0Q0rj0Am6EsOZfmE3AagE8gA6z/qdiNgBx8R13x6XJJXdpN/d1Svs0H2P/BaRTGmwLSepzoZQ+wDkBm0o45Fwzm+Xt11iBJ9ACR0LociQ+oo4lcEnCUAsAbzkne5G20XYEAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/arrow_down.png
// module id = 0+L1
// module chunks = 3